<template>
  <v-footer id="footer" height="auto" color="#174694">
    <v-container>
      <v-layout
        justify-center
        row
        wrap
        class="pt-2 ma-auto"
        style="max-width: 1120px"
      >
        <v-flex xs12 sm6 md9>
          <v-layout row wrap>
            <v-flex white--text xs12 md6>
              <h4>
                {{ $t('actions.learn_more') }}
              </h4>
              <ul v-for="link in links" :key="link.name" class="ml-0 pl-0 mb-3">
                <li v-if="link.nuxt">
                  <nuxt-link class="link" :to="link.url">
                    {{ link.name }}
                  </nuxt-link>
                </li>
                <li v-else>
                  <a class="link" :href="link.url" target="_blank">
                    {{ link.name }}
                  </a>
                </li>
              </ul>
            </v-flex>
            <v-flex white--text xs12 md6>
              <h4 class="text-capitalize">{{ $t('educators_page.elementariInClass') }} </h4>
              <ul
                v-for="link in educatorLinks"
                :key="link.name"
                class="ml-0 pl-0 mb-3"
              >
                <li v-if="link.nuxt">
                  <nuxt-link class="link" :to="link.url">
                    {{ link.name }}
                  </nuxt-link>
                </li>
                <li v-else>
                  <a class="link" :href="link.url">
                    {{ link.name }}
                  </a>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex white--text xs12 sm6 md3>
          <div class="mb-3">
            {{ $t('about_page.mission.content') }}
          </div>
          <v-layout>
            <div v-for="social in socials" :key="social.name">
              <v-btn :href="social.url" icon dark style="overflow: hidden">
                <v-icon size="lg">{{ getIcon(social.icon) }}</v-icon>
                <span style="text-indent: -999px">{{ social.name }}</span>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>

        <v-flex py-3 text-center white--text xs12 style="color: #174694">
          <div class="text-center mt-4">
            <p>Made with ♥ in France and USA</p>
            <p>© Elementari, LLC 2024</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    data() {
      return {
        socials: [
          {
            name: 'facebook',
            icon: 'mdiFacebook',
            url: 'https://www.facebook.com/elementariapp'
          },
          {
            name: 'twitter',
            icon: 'mdiTwitter',
            url: 'https://twitter.com/elementari'
          },
          {
            name: 'instagram',
            icon: 'mdiInstagram',
            url: 'https://www.instagram.com/elementari.io/'
          },
          {
            name: 'youtube',
            icon: 'mdiYoutube',
            url: 'https://www.youtube.com/c/elementari_io'
          },
          {
            name: 'linkedin',
            icon: 'mdiLinkedin',
            url: 'https://www.linkedin.com/company/elementari/'
          }
        ]
      }
    },
    computed: {
      links() {
        const links = [
          {
            name: this.$t('links.about'),
            url: this.localePath('/about/'),
            nuxt: true
          },
          {
            name: this.$t('links.features'),
            url: this.localePath('/features/'),
            nuxt: true
          },
          {
            name: this.$t('links.privacy'),
            url: this.localePath('/policy/privacy/'),
            nuxt: true
          },
          {
            name: this.$t('links.terms'),
            url: this.localePath('/policy/terms/'),
            nuxt: true
          },
          {
            name: this.$t('links.help_center'),
            url: 'https://help.elementari.com',
            nuxt: false
          },
          {
            name: this.$t('plans.contactUs'),
            url: this.localePath('/contact/'),
            nuxt: true
          }
        ]
        return links
      },
      educatorLinks() {
        const links = [
          {
            name: this.$t('links.schoolsAndDistricts'),
            url: this.localePath('/schools-districts/'),
            nuxt: true
          },
          {
            name: this.$t('links.getting_started'),
            url: this.localePath('/getting-started/'),
            nuxt: true
          },
          {
            name: 'Free Summer Professional Development',
            url: '/pathfinders-summer-pd-2025/',
            nuxt: true
          },
          {
            name: this.$t('links.whatIsVisualCoding'),
            url: this.localePath('/what-is-visual-coding/'),
            nuxt: true
          },
          {
            name: this.$t('links.whyCreativeCoding'),
            url: this.localePath('/why-creative-coding/'),
            nuxt: true
          },
          {
            name: this.$t('classroom.assignment.banner_title'),
            url: this.localePath('/lessons/'),
            nuxt: true
          },
          {
            name: this.$t('links.plans'),
            url: this.localePath('/plans/'),
            nuxt: true
          },
          {
            name: this.$t('plans.getInstantQuote'),
            url: this.localePath('/quote/'),
            nuxt: true
          }
        ]
        return links
      }
    },
    methods: {
      getIcon: function (iconName) {
        return this.$vuetify.icons.values[iconName]
      }
    }
  }
</script>

<style>
  #footer ul > li {
    list-style-type: none;
    line-height: 1.8;
  }
  #footer .link {
    color: rgba(255, 255, 255, 0.7);
    font-size: 18px;
    font-weight: 300;
  }
  #footer .link:hover {
    color: white;
  }
</style>
